import { h } from 'preact';
import { useState, useCallback, memo } from 'preact/compat';
import PageWrapper from '../PageWrapper';
import './style.scss';
import Button from '../Button';
import RadioGroup from '../RadioGroup';
import { AssistButtonAction, AssistButtonDeferredAction, AssistContent, AssistRenderType } from '../../types';
import { BackIcon, CloseIcon } from '../Icons';

interface Props {
  onHideModal: () => void;
  onNextStep: ({
    action,
    message,
    reason,
    renderType,
    deferredAction,
  }: {
    action: AssistButtonAction;
    deferredAction?: AssistButtonDeferredAction;
    message?: string;
    reason?: string;
    renderType: AssistRenderType;
  }) => void;
  content: AssistContent;
  renderType: AssistRenderType;
  lang: string;
}

function ReasonStep({ onHideModal, onNextStep, content, renderType }: Props) {
  const [reason, setReason] = useState<string>('');
  const [comment, setComment] = useState('');

  const handleSetReason = useCallback((value: string) => {
    setReason(value);
  }, []);

  const handleChangeComment = useCallback(({ target }: { target: EventTarget }) => {
    if (target instanceof HTMLTextAreaElement) {
      setComment(target.value);
    }
  }, []);

  return (
    <PageWrapper>
      <div className="modal-header_ta">
        {content?.additional?.backAction && (
          <BackIcon
            className="back-button_ta"
            color="#429EFF"
            size={26}
            onClick={() => onNextStep({ action: content.additional.backAction, renderType })}
          />
        )}
        <h1 className="secondary-page-title">{content.title}</h1>
        <CloseIcon className="close-button_ta" size={14} onClick={onHideModal} />
      </div>
      <div className="modal-body_ta reason-body">
        <h2 className="secondary-page-subtitle">{content.subtitle}</h2>
        <RadioGroup
          options={content.reasons}
          current={reason}
          onChange={handleSetReason}
          onChangeComment={handleChangeComment}
        />
        <div style={{ flex: 1 }}>&nbsp;</div>
        {reason &&
          content.buttons.map((button, i) => (
            <Button
              key={i}
              data={button}
              className={'buttons-wrapper_ta'}
              onClick={() =>
                onNextStep({
                  action: button.action,
                  deferredAction: button.deferred_action,
                  message: comment,
                  reason,
                  renderType,
                })
              }
            />
          ))}
      </div>
    </PageWrapper>
  );
}

export default memo(ReasonStep);
